/**
 * checklists.js — the standing checklists (Shopping · Backup · Cutting tabs).
 *
 * Unlike the daily board (one doc per noted item), these are persistent par-check
 * lists. Each purchase / cut is logged with a date to CHECKLIST_LOG_COLLECTION for
 * history and tracking; shopping items also carry a store (grouped + learned).
 */
export const CHECKLISTS = [
  {
    id: 'shopping',
    label: 'Shopping List',
    icon: '🛒',
    color: '#f59e0b',
    hasStore: true,              // which shop to buy each item from — grouped + learned from history
    verb: 'Bought',
    cadence: 'Tue · Fri',
    intro: 'Par-check list — tap items to add, set the store, and tick them off with the date you bought them.',
    seeds: [
      'Milk', 'Eggs', 'Water', 'Paneer', 'Butter', 'Garlic', 'Boneless chicken',
      'Carrots', 'Cool drinks', 'Potatoes', 'Lettuce', 'Heavy whipping cream', 'Napkins',
      'Thai chilli', 'Serrano peppers', 'Mint', 'Cilantro', 'Bottle guard', 'Curry leaves',
      'Green chilli sauce', 'Red chilli sauce', 'Panipoori masala', 'Chat masala', 'Ginger',
      'Red jumbo onions', 'Yellow jumbo onions', 'Tomatoes', 'Peeled garlic', 'Hot & sweet sauce',
      'Carrot & peas', 'Vinegar', 'Lemons', 'Wraps (tortillas)', 'Spring onions', 'Cauliflower',
      'Brown bags', 'Band-aids',
    ],
  },
  {
    id: 'backup',
    label: 'Backup Stock',
    icon: '📦',
    color: '#06b6d4',
    verb: 'Refilled',
    intro: 'Backup / reserve stock to keep topped up — frozen breads, snacks and spare to-go boxes. Tick each off with the date you restocked it, so nothing runs out mid-service.',
    seeds: [
      'Parathas', 'Naan', 'Samosa', 'Mini potato samosa',
      'Large togo boxes', 'Small togo boxes',
    ],
  },
  {
    id: 'cutting',
    label: 'Cutting',
    icon: '🔪',
    color: '#f43f5e',
    verb: 'Cut',
    intro: 'Prep-cutting list — tick each item off with the date it was cut.',
    seeds: [
      'Curry onions', 'Dosa onions', 'Pakodi onions', 'Boneless chicken',
      'Boneless chicken (roast)', 'Cabbage', 'Carrots', 'Capsicum', 'Spring onions',
      'Green chilies', 'Garlic', 'Ginger', 'Mint', 'Cilantro', 'Lemons', 'Paneer',
      'Baby corn', 'Rajma',
    ],
  },
];

// Starter store names offered in the store autosuggest before any history exists.
export const DEFAULT_STORES = ["Sam's", 'Costco', 'Restaurant Depot', 'Indian grocery', 'Walmart', 'Produce market'];
export const NO_STORE_LABEL = 'Unassigned';   // group heading for items with no store yet
